import React from 'react'

class Tabs extends React.Component {
    componentDidMount() {
        // console.log(this.tabList.offsetTop)
        // // // console.log(JSON.stringify(this.tabList))
        // // setTimeout(()=>{
        // //     window.scrollTo(0, this.tabList.offsetTop)
        // // }, 2000)

        // // console.log(this.tabList.scrollIntoView)
        // // this.tabList.scrollIntoView(true)
    }

    render() {
        var selectedTabContent = null
        var selectedTabName= null

        var forceSelectFirst = !this.props.selectedTab
            ? true
            : false

        var tabList = []

        React.Children.forEach(this.props.children, (child, id) => {
            if (child != null /*&& child.type.name === 'Tab'*/) {   // <--- some DANGER meme
                if (this.props.selectedTab===child.props.name || (forceSelectFirst && id===0)) {
                    selectedTabContent = child
                    selectedTabName = child.props.name
                }
                tabList.push({
                    title: child.props.title,
                    name: child.props.name
                })
            }
        })

        return (

            <div className="tabs" ref={c=>this.tabList=c}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-8 col-md-6 col-sm-12">
                            <ul className="tablist">
                                {
                                    tabList.map(tab => (
                                        <li key={tab.name}>
                                            <a  id={tab.name}
                                                className={'tabs-tablist-link' + (tab.name===this.props.selectedTab?' selected':'')}
                                                onClick={() => {this.props.onChangeTab(tab.name)}}
                                            >{tab.title}</a>
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            {this.props.Selector}
                        </div>
                    </div>
                    <div className="col-lg-12 tabs-content">
                        {selectedTabContent}
                    </div>
                </div>
            </div>

        )
    }
}

const Tab = ({ name, children }) => {
    return (
        <div id={`tab-${name}`} className="tabs-tab">
            {children}
        </div>
    )
}

export {
  Tabs,
  Tab
}



// WEBPACK FOOTER //
// ./src/components/Tabs.js